<template>
  <div class="content displayflexcontent home">
    <div class="homecoont posrel displayflexcontent">
      <div class="posa imgcon bg1">
        <img src="@/assets/imgs/logo.png" alt="logo" />
      </div>
      <div class="posa imgcon bg2">
        <img src="@/assets/imgs/znz.png" alt="指南针" />
      </div>
      <div class="posa rightbottm">
        <div class="imgcon cursorPointer" @click="lxrw">
          <img src="@/assets/imgs/lxrw.png" alt="乐享人文" />
        </div>
        <div class="imgcon cursorPointer" @click="qxing">
          <img src="@/assets/imgs/hlyd.png" alt="骑行" />
        </div>
        <div class="imgcon cursorPointer" @click="zxing">
          <img src="@/assets/imgs/stqy.png" alt="舟行" />
        </div>
      </div>
      <div class="homecoontFun">
        <div class="homecoontLeft posa">
          <div class="jsLeft1 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/A1.png" alt="" />
          </div>
          <div class="jsLeft2 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/A2.png" alt="" />
          </div>
          <div class="jsLeft3 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/A3.png" alt="" />
          </div>
          <div class="jsLeft4 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/A4.png" alt="" />
          </div>
          <div class="jsLeft5 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/A5.png" alt="" />
          </div>
          <div class="jsLeft6 imgcon posa cursorPointer" @click="(e)=>{htmlsurlsData('html3D/whzx/index.html')}">
              <img src="@/assets/imgs/proct/A6.png" alt="" />
          </div>
          <div class="jsLeft7 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/A7.png" alt="" />
          </div>
          <div class="jsLeft8 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/A8.png" alt="" />
          </div>
          <div class="jsLeft9 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/A9.png" alt="" />
          </div>
          <div class="jsLeft10 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/A10.png" alt="" />
          </div>
          <div class="jsLeft11 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/A11.png" alt="" />
          </div>
        </div>
        <div class="homecoontZhong posa">
          <div
            class="homecoontZhong0 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: islxrw }"
          >
            <img src="@/assets/imgs/jg0.png" alt="滑板公园" />
          </div>
          <div
            class="homecoontZhong1 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: isqxing }"
          >
            <img src="@/assets/imgs/jg1.png" alt="湾谷科技园" />
          </div>
          <div
            class="homecoontZhong2 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: iszxing }"
          >
            <img src="@/assets/imgs/jg2.png" alt="党群服务中心" />
          </div>
          <div
            class="homecoontZhong3 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: isqxing }"
          >
            <img src="@/assets/imgs/jg3.png" alt="复旦门" />
          </div>
          <div
            class="homecoontZhong4 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: isqxing }"
          >
            <img src="@/assets/imgs/jg4.png" alt="为老服务中心" />
          </div>
          <div
            class="homecoontZhong5 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: isqxing }"
          >
            <img src="@/assets/imgs/jg5.png" alt="源浦江汇江湾" />
          </div>
          <div
            class="homecoontZhong6 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: iszxing }"
          >
            <img src="@/assets/imgs/jg6.png" alt="观鸟亭" />
          </div>
          <div
            class="homecoontZhong7 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: islxrw }"
          >
            <img src="@/assets/imgs/jg7.png" alt="上海数学与交叉科学研究院" />
          </div>
          <div
            class="homecoontZhong8 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: islxrw || isqxing }"
          >
            <img src="@/assets/imgs/jg8.png" alt="生态展示馆" />
          </div>
          <div class="homecoontZhong9 imgcon posa">
            <img src="@/assets/imgs/jg9.png" alt="数字公园" />
          </div>
          <div
            class="homecoontZhong10 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: islxrw || iszxing }"
            @click="(e)=>{htmlsurlsData('html3D/whtygy/index.html')}"
          >
              <img src="@/assets/imgs/jg10.png" alt="文化体育公园" />
          </div>
          <div
            class="homecoontZhong11 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: islxrw }"
            @click="(e)=>{htmlsurlsData('html3D/whzx/index.html')}"
          >
              <img src="@/assets/imgs/jg11.png" alt="文化中心" />
          </div>
          <div
            class="homecoontZhong12 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: iszxing }"
          >
            <img src="@/assets/imgs/jg12.png" alt="德法学校" />
          </div>
          <div
            class="homecoontZhong13 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: iszxing }"
          >
            <img src="@/assets/imgs/jg13.png" alt="悠方广场" />
          </div>
          <div
            class="homecoontZhong14 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: islxrw }"
          >
            <img src="@/assets/imgs/jg14.png" alt="云际尚浦" />
          </div>
          <div
            class="homecoontZhong15 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: iszxing }"
          >
            <img src="@/assets/imgs/jg15.png" alt="中福会幼儿园" />
          </div>
          <div
            class="homecoontZhong16 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: islxrw }"
          >
            <img src="@/assets/imgs/jg16.png" alt="钻石连廊" />
          </div>
          <div
            class="homecoontZhong17 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: isqxing }"
          >
            <img src="@/assets/imgs/jg17.png" alt="樱花大道" />
          </div>
          <div
            class="homecoontZhong18 imgcon posa filtergrayscale"
            :class="{ filtergrayscale0: islxrw }"
          >
            <img src="@/assets/imgs/jg18.png" alt="生态走廊" />
          </div>
          <div class="homecoontZhong19 imgcon posa" v-show="islxrw && cshrw">
            <img src="@/assets/imgs/leslx.webp" alt="绿色路线" />
          </div>
          <div class="homecoontZhong20 imgcon posa" v-show="isqxing && cshrw">
            <img src="@/assets/imgs/hslx.webp" alt="红色路线" />
          </div>
          <div class="homecoontZhong21 imgcon posa" v-show="iszxing && cshrw">
            <img src="@/assets/imgs/lslx.webp" alt="蓝色路线" />
          </div>
          <div class="homecoontZhong22 cursorPointer imgcon posa" @click="lxrw">
            <img src="@/assets/imgs/manxing.png" alt="慢性" />
          </div>
          <div
            class="homecoontZhong23 cursorPointer imgcon posa"
            @click="qxing"
          >
            <img src="@/assets/imgs/qixing1.png" alt="骑行1" />
          </div>
          <div
            class="homecoontZhong24 cursorPointer imgcon posa"
            @click="qxing"
          >
            <img src="@/assets/imgs/qixing2.png" alt="骑行2" />
          </div>
          <div
            class="homecoontZhong25 cursorPointer imgcon posa"
            @click="zxing"
          >
            <img src="@/assets/imgs/zhouxing.png" alt="舟行" />
          </div>
        </div>
        <div class="homecoontRight posa">
          <div class="jsRight1 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/B1.png" alt="" />
          </div>
          <div class="jsRight2 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/B2.png" alt="" />
          </div>
          <div class="jsRight3 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/B3.png" alt="" />
          </div>
          <div class="jsRight4 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/B4.png" alt="" />
          </div>
          <div class="jsRight5 imgcon posa cursorPointer" @click="(e)=>{htmlsurlsData('html3D/whtygy/index.html')}">
              <img src="@/assets/imgs/proct/B5.png" alt="" />
          </div>
          <div class="jsRight6 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/B6.png" alt="" />
          </div>
          <div class="jsRight7 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/B7.png" alt="" />
          </div>
          <div class="jsRight8 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/B8.png" alt="" />
          </div>
          <div class="jsRight9 imgcon posa cursorPointer">
            <img src="@/assets/imgs/proct/B9.png" alt="" />
          </div>
        </div>
      </div>
      <div class="homeFunDer posa" v-if="htmlisshow">
        <iframe v-if="htmlisshow" :src="htmlsurls" width="100%" height="100%"></iframe>
        <div class="icon imgcon cursorPointer" @click="(e)=>{htmlsurlsDataFh()}">
          <img src="@/assets/imgs/IconParkOutlineBack.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HomeView",
  data() {
    return {
      islxrw: true,
      isqxing: true,
      iszxing: true,
      cshrw: false,
      htmlsurls:'',
      htmlisshow:false
    };
  },
  methods: {
    htmlsurlsData(strings){
      var that = this;
      that.htmlsurls=strings;
      that.htmlisshow=true;
    },
    htmlsurlsDataFh(){
      var that = this;
      that.htmlisshow=false;
      that.htmlsurls='';
    },
    lxrw() {
      var that = this;
      that.cshrw = true;
      that.islxrw = true;
      that.isqxing = false;
      that.iszxing = false;
    },
    qxing() {
      var that = this;
      that.cshrw = true;
      that.islxrw = false;
      that.isqxing = true;
      that.iszxing = false;
    },
    zxing() {
      var that = this;
      that.cshrw = true;
      that.islxrw = false;
      that.isqxing = false;
      that.iszxing = true;
    },
  },
};
</script>
<style scoped>
.home {
  background: url("@/assets/imgs/bg.png") no-repeat;
  background-size: 100% 100%;
}
.homecoont .imgcon img {
  width: 100%;
}
.homecoont .bg1 {
  width: 44.1797vw;
  left: 2.5781vw;
  top: 2.9297vw;
  z-index: 1;
}
.homecoont .bg2 {
  width: 12.6563vw;
  right: 3.8281vw;
  top: 2.9297vw;
  z-index: 1;
}
.homecoont .rightbottm {
  width: 27.5391vw;
  right: 3.8281vw;
  bottom: 4.6875vw;
  z-index: 1;
}
/* 横屏 */
.transformRotate .homecoont .bg1 {
  width: 44.1797vh;
  left: 2.5781vh;
  top: 2.9297vh;
  z-index: 1;
}
.transformRotate .homecoont .bg2 {
  width: 12.6563vh;
  right: 3.8281vh;
  top: 2.9297vh;
  z-index: 1;
}
.transformRotate .homecoont .rightbottm {
  width: 27.5391vw;
  right: 3.8281vw;
  bottom: 4.6875vw;
  z-index: 1;
}
/* 内容 */
/* 左侧 */
.homecoont .homecoontLeft {
  z-index: 3;
  width: 21.7969vw;
  height: 31.6797vw;
  top: 6.796900000000001vw;
  left: 4.0625vw;
}
.homecoont .homecoontLeft .jsLeft1 {
  width: 8.8281vw;
  height: 5.5078vw;
  top: 0px;
  left: 6.3672vw;
}
.homecoont .homecoontLeft .jsLeft2 {
  width: 8.6328vw;
  height: 5.4688vw;
  top: 5.3906vw;
  left: 0px;
}
.homecoont .homecoontLeft .jsLeft3 {
  width: 5.8594vw;
  height: 5.4688vw;
  top: 5.3906vw;
  left: 9.1406vw;
}
.homecoont .homecoontLeft .jsLeft4 {
  width: 4.375vw;
  height: 8.2031vw;
  top: 3.8281vw;
  right: 1.5625vw;
}
.homecoont .homecoontLeft .jsLeft5 {
  width: 4.5703vw;
  height: 8.2422vw;
  top: 10.9375vw;
  left: 1.3281vw;
}
.homecoont .homecoontLeft .jsLeft6 {
  width: 8.5547vw;
  height: 9.5313vw;
  top: 10.9766vw;
  left: 6.4453vw;
}
.homecoont .homecoontLeft .jsLeft7 {
  width: 4.4922vw;
  height: 8.0859vw;
  top: 12.1875vw;
  right: 1.5625vw;
}
.homecoont .homecoontLeft .jsLeft8 {
  width: 4.4531vw;
  height: 8.1641vw;
  bottom: 3.7891vw;
  left: 1.4063vw;
}
.homecoont .homecoontLeft .jsLeft9 {
  width: 5.7813vw;
  height: 5.2344vw;
  bottom: 5.625vw;
  right: 9.4531vw;
}
.homecoont .homecoontLeft .jsLeft10 {
  width: 8.6719vw;
  height: 5.2344vw;
  bottom: 5.5859vw;
  right: 0.0781vw;
}
.homecoont .homecoontLeft .jsLeft11 {
  width: 8.75vw;
  height: 5.2344vw;
  bottom: 0px;
  left: 6.4844vw;
}
/* 中间 */
.homecoont .homecoontZhong {
  width: 42.9688vw;
  height: 46.875vw;
  background: url("@/assets/imgs/htbg.png") no-repeat;
  background-size: 100% 100%;
  z-index: 2;
  top: 0;
  left: 50%;
  margin-left: -21.4844vw;
}
.homecoontZhong .homecoontZhong0 {
  width: 3.4766vw;
  height: 3.125vw;
  top: 9.4531vw;
  left: 18.8281vw;
  z-index: 9;
}

.homecoontZhong .homecoontZhong1 {
  width: 6.5625vw;
  height: 6.4844vw;
  top: 3.0078vw;
  left: 8.2031vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong2 {
  width: 3.9453vw;
  height: 3.5156vw;
  top: 8.6719vw;
  right: 12.7344vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong3 {
  width: 5.3125vw;
  height: 5.8203vw;
  top: 9.3359vw;
  left: 11.0547vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong4 {
  width: 4.1016vw;
  height: 3.5938vw;
  bottom: 20.6094vw;
  left: 8.3984vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong5 {
  width: 7.4219vw;
  height: 3.6719vw;
  top: 2.4609vw;
  left: 16.3281vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong6 {
  width: 5.5078vw;
  height: 7.0703vw;
  bottom: 18.9453vw;
  right: 15.9766vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong7 {
  width: 5.5469vw;
  height: 5.5469vw;
  bottom: 9.2969vw;
  left: 12.5vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong8 {
  width: 5.5078vw;
  height: 4.2578vw;
  bottom: 14.1406vw;
  left: 11.8359vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong9 {
  width: 5.2344vw;
  height: 3.3203vw;
  bottom: 8.9063vw;
  left: 6.9922vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong10 {
  width: 5.3516vw;
  height: 3.0469vw;
  top: 12.6172vw;
  left: 17.8906vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong11 {
  width: 3.2422vw;
  height: 4.0234vw;
  top: 11.25vw;
  left: 15.1563vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong12 {
  width: 3.125vw;
  height: 3.3594vw;
  bottom: 24.8828vw;
  right: 15.3516vw;
  z-index: 8;
}
.homecoontZhong .homecoontZhong13 {
  width: 4.6875vw;
  height: 2.8906vw;
  top: 15.8203vw;
  left: 12.8516vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong14 {
  width: 3.6719vw;
  height: 6.6406vw;
  bottom: 14.0625vw;
  left: 17.8906vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong15 {
  width: 3.9844vw;
  height: 3.6328vw;
  bottom: 23.2813vw;
  left: 17.1484vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong16 {
  width: 7.5391vw;
  height: 4.375vw;
  bottom: 5.8594vw;
  left: 13.5156vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong17 {
  width: 3.2813vw;
  height: 7.1094vw;
  top: 6.4063vw;
  right: 9.7656vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong18 {
  width: 8.0469vw;
  height: 16.1719vw;
  bottom: 21.1719vw;
  right: 8.9063vw;
  z-index: 9;
}
.homecoontZhong .homecoontZhong19 {
  width: 24.2188vw;
  height: 32.8125vw;
  top: 8.5938vw;
  right: 5.2578vw;
  z-index: 7;
}
.homecoontZhong .homecoontZhong20 {
  width: 27.5781vw;
  height: 30.8594vw;
  top: 3.5938vw;
  left: 3.9453vw;
  z-index: 7;
}
.homecoontZhong .homecoontZhong21 {
  width: 13.5938vw;
  height: 13.2031vw;
  top: 12.1094vw;
  left: 16.3281vw;
  z-index: 7;
}
.homecoontZhong .homecoontZhong22 {
  width: 3.4375vw;
  height: 5.3516vw;
  top: 6.0156vw;
  right: 5.625vw;
  z-index: 10;
}
.homecoontZhong .homecoontZhong23 {
  width: 3.4766vw;
  height: 5.3516vw;
  top: 3.0469vw;
  right: 16.4063vw;
  z-index: 10;
}
.homecoontZhong .homecoontZhong24 {
  width: 3.9844vw;
  height: 4.6094vw;
  bottom: 19.4141vw;
  left: 4.4531vw;
  z-index: 10;
}
.homecoontZhong .homecoontZhong25 {
  width: 5vw;
  height: 3.5156vw;
  top: 10.4297vw;
  right: 13.9453vw;
  z-index: 10;
}
/* 右侧 */
.homecoont .homecoontRight {
  z-index: 4;
  width: 28.2031vw;
  height: 19.1406vw;
  top: 10.156199999999998vw;
  right: 3.2813vw;
}
.homecoont .homecoontRight .jsRight1 {
  width: 5.7031vw;
  height: 4.2578vw;
  top: 1.875vw;
  left: 3.5156vw;
}
.homecoont .homecoontRight .jsRight2 {
  width: 8.5938vw;
  height: 6.2891vw;
  top: 0px;
  left: 9.8438vw;
}
.homecoont .homecoontRight .jsRight3 {
  width: 5.8594vw;
  height: 4.2578vw;
  top: 1.9531vw;
  right: 3.3594vw;
}
.homecoont .homecoontRight .jsRight4 {
  width: 6.7969vw;
  height: 5.7031vw;
  top: 6.6406vw;
  left: 0px;
}
.homecoont .homecoontRight .jsRight5 {
  width: 12.0703vw;
  height: 5.9766vw;
  top: 6.4453vw;
  left: 7.6953vw;
}
.homecoont .homecoontRight .jsRight6 {
  width: 7.6563vw;
  height: 5.7422vw;
  top: 6.4844vw;
  right: 0px;
}
.homecoont .homecoontRight .jsRight7 {
  width: 6.0156vw;
  height: 4.5703vw;
  bottom: 1.4453vw;
  left: 3.3203vw;
}
.homecoont .homecoontRight .jsRight8 {
  width: 8.5938vw;
  height: 6.5234vw;
  bottom: 0px;
  left: 9.7656vw;
}
.homecoont .homecoontRight .jsRight9 {
  width: 5.9766vw;
  height: 4.4922vw;
  bottom: 1.6406vw;
  right: 3.3203vw;
}
/* 横屏 */

/* 左侧 */
.transformRotate .homecoont .homecoontLeft {
  z-index: 3;
  width: 21.7969vh;
  height: 31.6797vh;
  top: 6.796900000000001vh;
  left: 4.0625vh;
}
.transformRotate .homecoont .homecoontLeft .jsLeft1 {
  width: 8.8281vh;
  height: 5.5078vh;
  top: 0px;
  left: 6.3672vh;
}
.transformRotate .homecoont .homecoontLeft .jsLeft2 {
  width: 8.6328vh;
  height: 5.4688vh;
  top: 5.3906vh;
  left: 0px;
}
.transformRotate .homecoont .homecoontLeft .jsLeft3 {
  width: 5.8594vh;
  height: 5.4688vh;
  top: 5.3906vh;
  left: 9.1406vh;
}
.transformRotate .homecoont .homecoontLeft .jsLeft4 {
  width: 4.375vh;
  height: 8.2031vh;
  top: 3.8281vh;
  right: 1.5625vh;
}
.transformRotate .homecoont .homecoontLeft .jsLeft5 {
  width: 4.5703vh;
  height: 8.2422vh;
  top: 10.9375vh;
  left: 1.3281vh;
}
.transformRotate .homecoont .homecoontLeft .jsLeft6 {
  width: 8.5547vh;
  height: 9.5313vh;
  top: 10.9766vh;
  left: 6.4453vh;
}
.transformRotate .homecoont .homecoontLeft .jsLeft7 {
  width: 4.4922vh;
  height: 8.0859vh;
  top: 12.1875vh;
  right: 1.5625vh;
}
.transformRotate .homecoont .homecoontLeft .jsLeft8 {
  width: 4.4531vh;
  height: 8.1641vh;
  bottom: 3.7891vh;
  left: 1.4063vh;
}
.transformRotate .homecoont .homecoontLeft .jsLeft9 {
  width: 5.7813vh;
  height: 5.2344vh;
  bottom: 5.625vh;
  right: 9.4531vh;
}
.transformRotate .homecoont .homecoontLeft .jsLeft10 {
  width: 8.6719vh;
  height: 5.2344vh;
  bottom: 5.5859vh;
  right: 0.0781vh;
}
.transformRotate .homecoont .homecoontLeft .jsLeft11 {
  width: 8.75vh;
  height: 5.2344vh;
  bottom: 0px;
  left: 6.4844vh;
}
/* 中间 */
.transformRotate .homecoont .homecoontZhong {
  width: 42.9688vh;
  height: 46.875vh;
  background: url("@/assets/imgs/htbg.png") no-repeat;
  background-size: 100% 100%;
  z-index: 2;
  top: 0;
  left: 50%;
  margin-left: -21.4844vh;
}
.transformRotate .homecoontZhong .homecoontZhong0 {
  width: 3.4766vh;
  height: 3.125vh;
  top: 9.4531vh;
  left: 18.8281vh;
  z-index: 9;
}

.transformRotate .homecoontZhong .homecoontZhong1 {
  width: 6.5625vh;
  height: 6.4844vh;
  top: 3.0078vh;
  left: 8.2031vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong2 {
  width: 3.9453vh;
  height: 3.5156vh;
  top: 8.6719vh;
  right: 12.7344vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong3 {
  width: 5.3125vh;
  height: 5.8203vh;
  top: 9.3359vh;
  left: 11.0547vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong4 {
  width: 4.1016vh;
  height: 3.5938vh;
  bottom: 20.6094vh;
  left: 8.3984vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong5 {
  width: 7.4219vh;
  height: 3.6719vh;
  top: 2.4609vh;
  left: 16.3281vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong6 {
  width: 5.5078vh;
  height: 7.0703vh;
  bottom: 18.9453vh;
  right: 15.9766vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong7 {
  width: 5.5469vh;
  height: 5.5469vh;
  bottom: 9.2969vh;
  left: 12.5vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong8 {
  width: 5.5078vh;
  height: 4.2578vh;
  bottom: 14.1406vh;
  left: 11.8359vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong9 {
  width: 5.2344vh;
  height: 3.3203vh;
  bottom: 8.9063vh;
  left: 6.9922vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong10 {
  width: 5.3516vh;
  height: 3.0469vh;
  top: 12.6172vh;
  left: 17.8906vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong11 {
  width: 3.2422vh;
  height: 4.0234vh;
  top: 11.25vh;
  left: 15.1563vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong12 {
  width: 3.125vh;
  height: 3.3594vh;
  bottom: 24.8828vh;
  right: 15.3516vh;
  z-index: 8;
}
.transformRotate .homecoontZhong .homecoontZhong13 {
  width: 4.6875vh;
  height: 2.8906vh;
  top: 15.8203vh;
  left: 12.8516vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong14 {
  width: 3.6719vh;
  height: 6.6406vh;
  bottom: 14.0625vh;
  left: 17.8906vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong15 {
  width: 3.9844vh;
  height: 3.6328vh;
  bottom: 23.2813vh;
  left: 17.1484vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong16 {
  width: 7.5391vh;
  height: 4.375vh;
  bottom: 5.8594vh;
  left: 13.5156vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong17 {
  width: 3.2813vh;
  height: 7.1094vh;
  top: 6.4063vh;
  right: 9.7656vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong18 {
  width: 8.0469vh;
  height: 16.1719vh;
  bottom: 21.1719vh;
  right: 8.9063vh;
  z-index: 9;
}
.transformRotate .homecoontZhong .homecoontZhong19 {
  width: 24.2188vh;
  height: 32.8125vh;
  top: 8.5938vh;
  right: 5.2578vh;
  z-index: 7;
}
.transformRotate .homecoontZhong .homecoontZhong20 {
  width: 27.5781vh;
  height: 30.8594vh;
  top: 3.5938vh;
  left: 3.9453vh;
  z-index: 7;
}
.transformRotate .homecoontZhong .homecoontZhong21 {
  width: 13.5938vh;
  height: 13.2031vh;
  top: 12.1094vh;
  left: 16.3281vh;
  z-index: 7;
}
.transformRotate .homecoontZhong .homecoontZhong22 {
  width: 3.4375vh;
  height: 5.3516vh;
  top: 6.0156vh;
  right: 5.625vh;
  z-index: 10;
}
.transformRotate .homecoontZhong .homecoontZhong23 {
  width: 3.4766vh;
  height: 5.3516vh;
  top: 3.0469vh;
  right: 16.4063vh;
  z-index: 10;
}
.transformRotate .homecoontZhong .homecoontZhong24 {
  width: 3.9844vh;
  height: 4.6094vh;
  bottom: 19.4141vh;
  left: 4.4531vh;
  z-index: 10;
}
.transformRotate .homecoontZhong .homecoontZhong25 {
  width: 5vh;
  height: 3.5156vh;
  top: 10.4297vh;
  right: 13.9453vh;
  z-index: 10;
}
/* 右侧 */
.transformRotate .homecoont .homecoontRight {
  z-index: 4;
  width: 28.2031vh;
  height: 19.1406vh;
  top: 10.156199999999998vh;
  right: 3.2813vh;
}
.transformRotate .homecoont .homecoontRight .jsRight1 {
  width: 5.7031vh;
  height: 4.2578vh;
  top: 1.875vh;
  left: 3.5156vh;
}
.transformRotate .homecoont .homecoontRight .jsRight2 {
  width: 8.5938vh;
  height: 6.2891vh;
  top: 0px;
  left: 9.8438vh;
}
.transformRotate .homecoont .homecoontRight .jsRight3 {
  width: 5.8594vh;
  height: 4.2578vh;
  top: 1.9531vh;
  right: 3.3594vh;
}
.transformRotate .homecoont .homecoontRight .jsRight4 {
  width: 6.7969vh;
  height: 5.7031vh;
  top: 6.6406vh;
  left: 0px;
}
.transformRotate .homecoont .homecoontRight .jsRight5 {
  width: 12.0703vh;
  height: 5.9766vh;
  top: 6.4453vh;
  left: 7.6953vh;
}
.transformRotate .homecoont .homecoontRight .jsRight6 {
  width: 7.6563vh;
  height: 5.7422vh;
  top: 6.4844vh;
  right: 0px;
}
.transformRotate .homecoont .homecoontRight .jsRight7 {
  width: 6.0156vh;
  height: 4.5703vh;
  bottom: 1.4453vh;
  left: 3.3203vh;
}
.transformRotate .homecoont .homecoontRight .jsRight8 {
  width: 8.5938vh;
  height: 6.5234vh;
  bottom: 0px;
  left: 9.7656vh;
}
.transformRotate .homecoont .homecoontRight .jsRight9 {
  width: 5.9766vh;
  height: 4.4922vh;
  bottom: 1.6406vh;
  right: 3.3203vh;
}

/* 居中处理 */
.homecoont {
  width: 100vw;
  height: 100vh;
}
.homecoontFun {
  display: block;
  height: 46.875vw;
  width: 100vw;
  position: relative;
  margin-top: 8vw;
}
.transformRotate .homecoontFun {
  display: block;
  height: 46.875vh;
  width: 100vh;
  position: relative;
  margin-top: 8vh;
}
.transformRotate .homecoont {
  width: 100vh;
  height: 100vw;
}
.homeFunDer{
  width: 100vw;
  height: 100vh;
  top:0;
  left: 0;
  z-index: 20;
}
.transformRotate .homeFunDer {
  width: 100vh;
  height: 100vw;
}
.homeFunDer .icon{
  position: absolute;
  z-index: 2;
  bottom: 1.1719vw;
  right: 1.1719vw;
  width: 1.5625vw;
  height: 1.5625vw;
}

</style>
